// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success[data-v-670ed4d0]{color:var(--success)}.fail[data-v-670ed4d0]{color:var(--danger)}.unknown[data-v-670ed4d0]{color:var(--warning)}`, "",{"version":3,"sources":["webpack://./client/components/TableCells/TableCellSuccess.vue"],"names":[],"mappings":"AAOA,0BACE,oBAAA,CAGF,uBACE,mBAAA,CAGF,0BACE,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
